import Vue from 'vue'
import Vuex from 'vuex'

import { alert } from './alert.module'
import { authentication } from './authentication.module'
import { combobox } from './selected-cbx.module'
import { unit } from './unit.module'
import { reportUser } from './report-users.module'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    authentication,
    alert,
    combobox,
    unit,
    reportUser
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js